import {NinchatActionType} from 'api/types/actions'
import {createAsyncThunk} from '@reduxjs/toolkit'
import {disableStorage} from 'store/storage'
import {initialState} from 'api/slice'
import ninchatClient from 'api/NinchatClient'

const actionTypePrefix = 'NINCHAT/action'

type CloseSessionAsyncThunkConfig = {pendingMeta: {reducer: () => typeof initialState}}

export const closeSession = createAsyncThunk<void, undefined, CloseSessionAsyncThunkConfig>(
    `${actionTypePrefix}/${NinchatActionType.NinchatCloseSessionAction}`,
    (_, thunkAPI) => {
        try {
            disableStorage()
            ninchatClient.close()
            return undefined
        } catch (err) {
            return thunkAPI.rejectWithValue(err)
        }
    },
    {getPendingMeta: () => ({reducer: () => initialState})},
)
